import angular from 'angular';

angular.module('AaApp.Opp').constant('eulaResponseTypes', {
    accept: 1,
    decline: 2,
    defer: 3
});
